import { render, staticRenderFns } from "./DailyNoticeModal.vue?vue&type=template&id=2ed2ca74&scoped=true"
import script from "./DailyNoticeModal.vue?vue&type=script&lang=js"
export * from "./DailyNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./DailyNoticeModal.vue?vue&type=style&index=0&id=2ed2ca74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2ca74",
  null
  
)

export default component.exports